const axios = require("axios");
const baseUrl =
  window.location.href.split("/")[2] === "crm.cloudvillage.it"
    ? "https://backendcrm.cloudvillage.it:7751"
    : window.location.href.split("/")[2] === "crmtest.cloudvillage.it"
    ? "https://backendcrmtest.cloudvillage.it:7752"
    : "https://backend.cloudvillage.it:7751";

export default {
  //* addQuote ---------------------------------------------------------------------------------------------------------------

  addQuote(context, data) {
    context.commit("addQuote", data);
  },

  //* updateTipologie ---------------------------------------------------------------------------------------------------------------

  async updateTipologie({ rootGetters, commit }) {
    var ret_val = 400,
      tok = "Bearer " + rootGetters["auth/getToken"];
    await axios({
      method: "post",
      url: "/cv/api/tipologie",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
    }).then(function (response) {
      if (response.statusText == "OK") {
        ret_val = 200; // means ok, all right (http protocol)
        commit("updateTipologie", response.data);
      }
    });
    return ret_val;
  },

  //* updateTipologieCamp ---------------------------------------------------------------------------------------------------------------

  async updateTipologieCamp({ commit }, campID) {
    var ret_val = 400;
    await axios({
      method: "POST",
      url: "/cv/api/tipologieCamp",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors",
      data: JSON.stringify({ camp: campID }),
    }).then(function (response) {
      if (response.statusText == "OK") {
        ret_val = 200; // means ok, all right (http protocol)
        commit("updateTipologie", response.data);
      }
    });
    return ret_val;
  },

  //* updateTipiPersona ---------------------------------------------------------------------------------------------------------------

  async updateTipiPersona({ rootGetters, commit }) {
    var ret_val = 400,
      tok = "Bearer " + rootGetters["auth/getToken"];
    // console.log(tok)
    await axios({
      method: "post",
      url: "/cv/api/tipiPersona",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
    }).then(function (response) {
      if (response.statusText == "OK") {
        ret_val = 200; // means ok, all right (http protocol)
        var responseData = response.data.sort(function (a, b) {
          return parseInt(b.ordinamento) - parseInt(a.ordinamento);
        });
        // console.log(responseData)
        commit("updateTipiPersona", responseData);
      }
    });
    return ret_val;
  },

  //* getOfferta ---------------------------------------------------------------------------------------------------------------

  async getOfferta({ rootGetters, commit }, request) {
    var ret_val = "",
      tok = "Bearer " + rootGetters["auth/getToken"];
    // console.log(tok)
    await axios({
      method: "post",
      url: "/getOfferta",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
      data: request,
    }).then(function (response) {
      // console.log(response)
      ret_val = response.data;
    });
    return ret_val.data;
  },

  //* getListino ---------------------------------------------------------------------------------------------------------------

  async getListino({ rootGetters, commit }, request) {
    var ret_val = "",
      tok = "Bearer " + rootGetters["auth/getToken"];
    // console.log(tok)
    await axios({
      method: "post",
      url: "/getListino",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors",
      data: request,
    }).then(function (response) {
      // console.log(response)
      ret_val = response.data;
    });
    return ret_val.data;
  },

  //* updateTipiPersonaCamp ---------------------------------------------------------------------------------------------------------------

  async updateTipiPersonaCamp({ commit }, campID) {
    var ret_val = 400;
    await axios({
      method: "post",
      url: "/cv/api/tipiPersonaCamp",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors",
      data: JSON.stringify({ camp: campID }),
    }).then(function (response) {
      if (response.statusText == "OK") {
        ret_val = 200; // means ok, all right (http protocol)
        commit("updateTipiPersona", response.data);
      }
    });
    return ret_val;
  },

  //* updateMezziCamp ---------------------------------------------------------------------------------------------------------------

  async updateMezziCamp({ commit }, campID) {
    var ret_val = 400;
    await axios({
      method: "post",
      url: "/cv/api/mezziCamp",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors",
      data: JSON.stringify({ camp: campID }),
    }).then(function (response) {
      if (response.statusText == "OK") {
        // console.log(response.data)
        ret_val = 200; // means ok, all right (http protocol)
        commit("updateMezzi", response.data);
      }
    });
    return ret_val;
  },

  //* updateMezzi ---------------------------------------------------------------------------------------------------------------

  async updateMezzi({ rootGetters, commit }) {
    var ret_val = 400,
      tok = "Bearer " + rootGetters["auth/getToken"];
    await axios({
      method: "post",
      url: "/cv/api/mezzi",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
    }).then(function (response) {
      if (response.statusText == "OK") {
        ret_val = 200; // means ok, all right (http protocol)
        commit("updateMezzi", response.data);
      }
    });
    return ret_val;
  },

  //* updateServiziCamp ---------------------------------------------------------------------------------------------------------------

  async updateServiziCamp({ commit }, campID) {
    var ret_val = 400;
    await axios({
      method: "post",
      url: "/cv/api/serviziCamp",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors",
      data: JSON.stringify({ camp: campID }),
    }).then(function (response) {
      if (response.statusText == "OK") {
        ret_val = 200; // means ok, all right (http protocol)
        commit("updateServizi", response.data);
      }
    });
    return ret_val;
  },

  //* updateServiziFormCamp ---------------------------------------------------------------------------------------------------------------

  async updateServiziFormCamp({ commit }, campID) {
    var ret_val = 400;
    await axios({
      method: "post",
      url: "/cv/api/serviziFormCamp",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors",
      data: JSON.stringify({ camp: campID }),
    }).then(function (response) {
      if (response.statusText == "OK") {
        ret_val = 200; // means ok, all right (http protocol)
        commit("updateServiziForm", response.data);
      }
    });
    return ret_val;
  },

  //* updateServizi ---------------------------------------------------------------------------------------------------------------

  async updateServizi({ rootGetters, commit }) {
    var ret_val = 400,
      tok = "Bearer " + rootGetters["auth/getToken"];
    await axios({
      method: "post",
      url: "/cv/api/servizi",
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
    }).then(function (response) {
      if (response.statusText == "OK") {
        ret_val = 200; // means ok, all right (http protocol)
        commit("updateServizi", response.data);
      }
    });
    return ret_val;
  },

  //* getCampingOrari ---------------------------------------------------------------------------------------------------------------

  async getCampingOrari({ rootGetters /*, commit*/ }, data) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    try {
      await fetch(base_address + "/getCamping/orari/" + data, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* setCampingOrari ---------------------------------------------------------------------------------------------------------------

  async setCampingOrari({ rootGetters /*, commit*/ }, payload) {
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/setCamping/orari", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = true; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getCampingContatti ---------------------------------------------------------------------------------------------------------------

  async getCampingContatti({ rootGetters /*, commit*/ }, data) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    try {
      await fetch(base_address + "/getCamping/contatti/" + data, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* setCampingContatti ---------------------------------------------------------------------------------------------------------------

  async setCampingContatti({ rootGetters /*, commit*/ }, payload) {
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/setCamping/contatti", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = true; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getCampingOccupazione ---------------------------------------------------------------------------------------------------------------

  async getCampingOccupazione({ rootGetters /*, commit*/ }) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    try {
      await fetch(base_address + "/getCamping/occupazione", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* setCampingOccupazione ---------------------------------------------------------------------------------------------------------------

  async setCampingOccupazione({ rootGetters /*, commit*/ }, payload) {
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/setCamping/occupazione", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getCampiFormContatti ---------------------------------------------------------------------------------------------------------------

  // ------------------------- form campi obbligatori
  async getCampiFormContatti({ rootGetters /*, commit*/ }) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    try {
      await fetch(base_address + "/getCamping/campiFormContatti", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* setCampiFormContatti ---------------------------------------------------------------------------------------------------------------

  async setCampiFormContatti({ rootGetters /*, commit*/ }, payload) {
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/setCamping/campiFormContatti", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = true; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },
};
